import { createRoot } from "react-dom/client"
import { QueryProvider } from "./providers/QueryProvider"
import { RouterProvider } from "./providers/RouterProvider"
import { TMAProvider } from "./providers/TMAProvider"
import { ToastProvider } from "./providers/ToastProvider"
import { UserProvider } from "./providers/UserProvider"
import { PostHogProvider } from "posthog-js/react"
import { BrowserRouter } from "react-router-dom"
import posthog from "posthog-js"
import * as Sentry from "@sentry/react"

import "./styles/index.css"
import "./styles/App.css"

import "@/shared/i18n/i18n"
import Error from "./error"

posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  person_profiles: "identified_only",
  persistence: "localStorage",
})

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.browserProfilingIntegration(),
    Sentry.browserApiErrorsIntegration(),
    Sentry.captureConsoleIntegration(),
  ],
  tracePropagationTargets: [/^https:\/\/(?!.*(posthog)).*\.funfiesta\.games/],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
  profilesSampleRate: 0.1,
})

const FallbackError = ({
  error,
  resetError,
}: {
  error: unknown
  resetError: () => void
}) => {
  return <Error error={error as Error} resetError={resetError} />
}

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
createRoot(document.querySelector("#root") as Element).render(
  <Sentry.ErrorBoundary fallback={FallbackError} showDialog>
    <PostHogProvider client={posthog}>
      <BrowserRouter>
        <QueryProvider>
          <TMAProvider>
            <ToastProvider>
              <UserProvider>
                <RouterProvider />
              </UserProvider>
            </ToastProvider>
          </TMAProvider>
        </QueryProvider>
      </BrowserRouter>
    </PostHogProvider>
  </Sentry.ErrorBoundary>
)
